<template>
  <v-form ref="form" autocomplete="off">
    <v-row>

      <v-col cols="12" sm="6">
        <v-text-field
            prepend-icon="checklist"
            name="state"
            :value="getState"
            :label="$t('delivery.orderState.labels.state')"
            :placeholder="$t('delivery.orderState.labels.state')"
            :error="hasInputErrors('state')"
            :error-messages="getInputErrors('state')"
            color="secondary"
            readonly
        ></v-text-field>
      </v-col>


      <v-col cols="12" sm="6">
        <v-text-field

            prepend-icon="store"
            name="takeAwayMessage"
            v-model="form.takeAwayMessage"
            :label="$t('delivery.orderState.labels.takeAwayMessage')"
            :placeholder="$t('delivery.orderState.labels.takeAwayMessage')"
            :error="hasInputErrors('takeAwayMessage')"
            :error-messages="getInputErrors('takeAwayMessage')"
            color="secondary"

        ></v-text-field>
      </v-col>


      <v-col cols="12" sm="6">
        <v-text-field

            prepend-icon="delivery_dining"
            name="deliveryMessage"
            v-model="form.deliveryMessage"
            :label="$t('delivery.orderState.labels.deliveryMessage')"
            :placeholder="$t('delivery.orderState.labels.deliveryMessage')"
            :error="hasInputErrors('deliveryMessage')"
            :error-messages="getInputErrors('deliveryMessage')"
            color="secondary"

        ></v-text-field>
      </v-col>

    </v-row>
  </v-form>
</template>

<script>

import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'


export default {
  name: "OrderStateForm",
  mixins: [InputErrorsByProps, RequiredRule],

  props: {
    value: {
      type: Object,
      required: true
    },
  },
  computed: {
    form: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    getState() {
      return this.$t('delivery.states.' + this.form.state)
    }
  },
  watch: {
    form: {
      handler(newVal) {
        this.$emit('input', newVal)
      },
      deep: true
    }
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    }
  },
  data() {
    return {}
  }
}
</script>

<style scoped>

</style>

